import AboutWhoWeAre from "./AboutWhoWeAre";
import AboutPhilosophy from "./AboutPhilosophy";
import AboutVision from "./AboutVision";

export const AboutStudio = () => (
  <>
    <AboutWhoWeAre />
    <AboutPhilosophy />
    <AboutVision />
  </>
);

export default AboutStudio;
